import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=5d7d3c54&"
import script from "./PartnersPage.vue?vue&type=script&lang=js&"
export * from "./PartnersPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnersPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
